
<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,

  data() {
    return {
      num: 0,
      hospitaltype: "审批中心",
      table: {
        mname: "approvalcenter",
        key: "id",
        url: {
          list: "/admin/approve/list",
        },
        output: false,
        order: 'id',
        qrCode: "qrCode",
      },
      tableCols: [
        {
          // type:'expand',
          align: 'center',
          title: '审批编号',
          key: 'approveNumber'
        }, {
          title: '商品信息',
          align: 'center',
          width: 350,
          render: (h, p) => {

            let html = [];
            for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
              html.push(
                <div style="border-top:1px solid rgb(232, 234, 236);">
                  <img  src={this.loadimg(p.row.sysCommodityDto[i].commodityImage)} style="width:60px;height:60px;float:left;margin-right:30px;margin-top:5px" />
                  <div style="padding:15px">
                    <p style="text-align:left">商品名称：{p.row.sysCommodityDto[i].commodityName}</p>
                    <p style="text-align:left">商品编号：{p.row.sysCommodityDto[i].commodityNumber}</p>
                  </div>
                </div>
              );
            }
            return (
              <div>
                {html}
              </div>
            )
          }
        }, {
          title: '申请数量',
          align: 'center',
          width: 100,
          render: (h, p) => {
            let html = [];
            for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
              html.push(
                <p style="margin:26px 0px">{p.row.sysCommodityDto[i].commodityQuantity}</p>
              );
            }
            return (
              <div >
                {html}
              </div>
            )
          }
        }, {
          title: '审批状态',
          align: 'center',
          width: 100,
          render: (h, p) => {
            const status = p.row.approveStatus
            if (status == 0) {
              return <p style="color: red">驳回</p>
            } else if (status == 1) {
              return <p style="color: skyblue">审批中</p>
            } else if (status == 2) {
              return <p style="color: green">审批完成</p>
            }else if (status == 3) {
              return <p style="color: green">已撤回</p>
            }
          },
        }, {
          title: '商品合计',
          width: 100,
          align: 'center',
          render: (h, p) => {
            return (
              <p>{p.row.sysCommodityDto.length}个产品</p>
            )
          }
        }, {
          title: '购买医院',
          key: '',
          width: 200,
          align: 'center',
          render: (h, p) => {
            return (
              <p>第六人民医院</p>
            )
          }
        }, {
          title: '创建时间',
          key: 'createTime',
          width: 220,
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          //           key: "handle",
          //           handle: [
          //               "edit",
          //               "delete"
          //             ],
          //             auth: {
          //               edit: "/admin/hospitalOrder/edit",
          //               del: "/admin/hospitalOrder/delete",
          //         //             },
          render: (h, params) => {
            if (params.row.approveStatus ==1) {
              return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                  },
                  style: {
                    margin: '0 5px',
                  },
                  on: {
                    click: () => {
                      this.RowCLick(params)
                    },
                  },
                },
                '查看详情'
              ),
              h(
                'Button',
                {
                  props: {
                    type:"success"
                  },
                  style: {
                    margin: '0 5px',
                  },
                  // 自定义指令
                  on: {
                    click: (e) => {
                      e.stopPropagation()
                      this.approvalPass(params)
                    },
                  },
                },
                '通过'
              ),
              h(
                'Button',
                {
                  props: {
                    type:"error"
                  },
                  style: {
                    margin: '0 5px',
                  },
                  // 自定义指令
                  on: {
                    click: (e) => {
                      e.stopPropagation()
                      this.overrule(params)
                    },
                  },
                },
                '驳回'
              ),
            ]
              // <Space direction="vertical">
              //   <Space wrap >
              //     <Button type="info">查看详情</Button>
              //     <Button type="success" style="margin:0px 10px" onclick={() => this.approvalPass(params)} >通过</Button>
              //     <Button type="error"  onclick={() => this.overrule(params)}>驳回</Button>
              //   </Space>
              // </Space>
             );    
            }else{
              return (
              <Space direction="vertical">
                <Space wrap >
                  <Button type="info"  onClick={() => this.RowCLick(params)}>查看详情</Button>
                </Space>
              </Space>
               );
            }
          }
        },
      ],
      filters: [
        { label: '审批编号', name: 'approveNumber', value: '', type: 'input' },
      ],
      menus: [
      ],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    RowCLick(e) {
      $utils.url.push({ path: "approvaldetails", query: { id: e.row.id } });
    },
            // 通过
        async approvalPass(e) {
            // 审批状态
            e.row.approveStatus += 1
            // 审批流程图
            let p = {}
            p.id = e.row.id
            p.approveStatus = e.row.approveStatus
            try{
              let res = await $utils.api.load(`/admin/approve/updateStatus`, p, 'get')
              if (res.status) {
                  $utils.toast.success('保存成功')
              }
            }catch(e){
              $utils.toast.error('保存异常' + e.message)
            }
        },
        // 驳回
        async overrule(e) {
            // 审批状态
            e.row.approveStatus = 0

            let p = {}
            p.id = e.row.id
            p.approveStatus = 0
            try{
              let res = await $utils.api.load(`/admin/approve/updateStatus`, p, 'get')
              if (res.status) {
                  $utils.toast.success('保存成功')
              }
            }catch(e){
              $utils.toast.error('保存异常' + e.message)
            }
        },
  }
}
</script>